export const SSO_ENROLL = 'events/SSO_ENROLL';

/**
 * @param idtoken
 * @param vendor
 * @return {{type: string, payload: {idtoken: *,vendor: *}}}
 */
export const ssoEnroll = (idtoken, vendor) => ({
  type: SSO_ENROLL,
  payload: { idtoken, vendor },
});
